const prod = {
    "bffUrl": "https://cms-ui-bff.vuclip.com",
    "momentsServiceUrl": "http://ottservice.cmsprod.internal/content-ott-service",
    "thumbnailUrlBase": "https://p.vuclip.com/p",
    "contextServiceUrl": "http://contextservice.cmsprod.internal/api/contextService/",
    "advisoryBaseUrl": "https://dirt0-prod.vuclip.com/api",
    "drmServiceUrl": "https://cmsscripts-prod.vuclip.com/drm",
    "cmsURL":"https://cmsscripts-prod.vuclip.com",
    "gCloudUrl":"https://storage.cloud.google.com/marketing-thumbnail",
    "akamaiUrl":"https://i.cdn.vuclip.com/ott-marketing",
    "lowresUrl":"https://pp1.vuclip.com/lowres2",
    "microdramaFileUploadUrl": "https://cmsscripts-prod.vuclip.com/microdrama/upload"
};

export default prod;